var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "ave__container" },
    [
      _vm.eyecatcherLines.length
        ? _c("ave-eyecatcher", { attrs: { lines: _vm.eyecatcherLines } })
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "ave__search__input" }, [
        _c(
          "label",
          { staticClass: "ave__search__label", attrs: { for: "ave_search" } },
          [_vm._v(_vm._s(_vm.$t("keyword.label")))]
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "ave__search__input--input-icon" },
          [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.text_query,
                  expression: "text_query",
                },
              ],
              staticClass: "search__field",
              attrs: {
                type: "text",
                maxlength: "100",
                id: "ave_search",
                placeholder: _vm.$t("keyword.placeholder"),
              },
              domProps: { value: _vm.text_query },
              on: {
                input: function ($event) {
                  if ($event.target.composing) return
                  _vm.text_query = $event.target.value
                },
              },
            }),
            _vm._v(" "),
            _vm.text_query !== ""
              ? _c("global-button", {
                  staticClass: "ave_search__reset",
                  attrs: { theme: "secondary", icon: "close" },
                  on: { click: _vm.reset },
                })
              : _vm._e(),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c("ave-search", { attrs: { query: _vm.text_query } }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }